/* Global constants
================================ */
const
	$B = $('body'),
	isTouchDevice = () => {
		return(
			('ontouchstart' in window) ||
			(navigator.maxTouchPoints > 0) ||
			(navigator.msMaxTouchPoints > 0)
		);
	};

/* Easing
================================ */
const
	speed   = 300,
	speedx2 = speed*2,
	ease    = 'easeInOutQuint';

/* Init
================================ */
// function heightViewport(){
// 	document.documentElement.style.cssText = `
// 		--height-viewport: ${window.innerHeight}px;
// 	`;
// }

/* Language
================================ */
$('#language').change(function(){
	location.replace($(this).val());
});

/* Currency
==================================== */
const api = "https://api.exchangerate-api.com/v4/latest/TWD"
function changeCurrency(conversion){
	$('html').attr('currency', conversion)
	fetch(`${api}`)
		.then((response) => response.json())
		.then((data) => {
			let x = data.rates['TWD'],
					y = data.rates[conversion];
			$('.money').each(function(e){
				var t = $(this),
						val = t.attr('val').split(',').join(''),
						money = (y/x)*val,
						txt = money.toLocaleString('en', {
						minimumFractionDigits: 0,
						maximumFractionDigits: 0,
					})
				t.text(txt);
			})
		});
}
var currency = localStorage.getItem('currency')
if(currency != null && currency != ''){
	var conversion = currency;
	changeCurrency(conversion)
	$('#currency option[value='+conversion+']').attr('selected', 'selected')
}else{
	if($('html').attr('currency') == 'USD'){
		var conversion = 'USD'
		changeCurrency(conversion)
	}
}
$('#currency').change(function(){
	var conversion = $(this).val();
	changeCurrency(conversion)
	localStorage.setItem('currency', conversion);
})

/* Marquees
======================================== */
const $M = $('#banner');
function marquee(){
	if($M.find('wrap').width() > window.innerWidth){
		if(!$M.hasClass('active')){
			$M.addClass('active').find('wrap').clone().addClass('clone').insertBefore($M.find('wrap'))
		}
	}else{
		$M.removeClass('active').find('.clone').remove()
	}
}
if($M.length){
	marquee()
	window.onresize = function(){
		marquee()
	}
}

/* Device detection
================================ */
if(/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent || navigator.vendor || window.opera) || isTouchDevice() == true){

	//If device
	$B.addClass('mobile');

	//Pseudoclass :active on devices
	document.addEventListener('touchstart', function(){}, {passive: true});

	//Resize Functions
	// window.addEventListener('orientationchange', function(){
	// 	setTimeout(function(){
	// 		heightViewport()
	// 	}, 50);
	// });

}else{

	//if Desktop
	$B.addClass('desktop');

	//Resize Functions
	// window.onresize = function(){
	// 	heightViewport()
	// }
	
	//Keyboard functions
	$(document).keyup(function(e){
		if(e.key == 'Escape' && $B.hasClass('popup-active')){
			closeIntro()
		}
	})

}

/* Loader
================================ */
// heightViewport()
setTimeout(function(){
	$('#loader').fadeOut(speedx2);
}, speedx2);

/* Intro
================================ */
const intro = $('#popup-wrapper');
function closeIntro(){
	intro.fadeOut(speedx2, function(){
		$B.removeClass('popup-active');
		sessionStorage.setItem('intro', false);
	});
}
intro.click(function(){
	closeIntro()
})
if(sessionStorage.getItem('intro') == 'false'){
	intro.remove()
	$B.removeClass('popup-active')
}else{
	intro.show();
}

/* Draggable modules
================================ */
var
	p,
	drag = $('.draggable');
if(drag.length){
	drag.each(function(){
		var
			t = $(this),
			scroller,
			timer = function(){
				scroller = setInterval(function(){
                    if(window.innerWidth > 834){
    					var psw = Math.ceil(t.get(0).scrollWidth),
    						 pos = Math.ceil(t.scrollLeft());
    					if(psw - pos > window.innerWidth){
    						t.scrollLeft(++pos);
    					}
                    }
				}, 25);
			},
			observer = new IntersectionObserver(function(E){
				E.forEach(function(entry){
					if(window.innerWidth > 834){
						if(entry.isIntersecting){
							clearInterval(scroller);
							timer();
						}else{
							clearInterval(scroller);
						}
					}else{
                        clearInterval(scroller);
                    }
				});
			});
		if($B.hasClass('desktop')){
			t.draggable({
				start: function(){
					p = $(this).scrollLeft();
				},
				drag: function(e, ui){
					if(window.innerWidth > 834){
						$(this).scrollLeft(p + ui.position.left * -1);
						clearInterval(scroller);
					}
				},
				stop: function(){
					timer()
				}
			});
		}else{
			t.on('touchstart', function(){
				clearInterval(scroller);
			}).on('touchend', function(){
				timer()
			});
		}
		observer.observe(t[0]);
	});
}

/* Filters Trigger
==================================== */
const
	filters = $('#filters'),
	fTrigger = $('#filters-trigger');
function toggleFilters(){
	fTrigger.toggleClass('active');
	filters.slideToggle(speedx2, ease, function(){
		filters.removeClass('transition');
	});
}
fTrigger.click(function(){
	var t = $(this),
		 top = Math.floor($(window).scrollTop()),
		 time = speed;
	if(!t.hasClass('clear')){

		if(!filters.hasClass('transition')){
			filters.addClass('transition')
			if(top < window.innerHeight/3){
				toggleFilters()
			}else{
				if(top > speed){
					time = top
				}
				if(top > speedx2){
					time = speedx2
				}
				$('html, body').animate({
					scrollTop: 0
				}, time, ease)
				setTimeout(function(){
					toggleFilters()
				}, time+100)
			}
		}

	}else{

		$('#filters-trigger, #filters, .module-collection').removeClass('clear empty')
		$('.filters-wrapper input').removeClass()
		$('.filter').removeClass('active')
		$('.product').removeClass('active-vendor active-category');

	}

});
// $(window).scroll(function(){
// 	if($(this).scrollTop() > window.innerHeight && filters.is(':visible')){
// 		if(!fTrigger.hasClass('clear')){
// 			fTrigger.removeClass('active');
// 		}
// 		filters.hide()
// 	}
// })

/* Filters
==================================== */
$('.filter').click(function(){
	var t = $(this),
		 active = t.parents('.filters-wrapper').find('input'),
		 type = t.data('type'),
		 val = t.data('filter');

	//Active/deactive filter
	t.toggleClass('active');

	//Hide projects
	$('.product').addClass('active-'+type);

	//Filter
	active.toggleClass(val);
	var fa = active.attr('class'),
		 ca = fa.split(/\s+/);
	$.each(ca, function(index, v){
		$('.product'+v).removeClass('active-'+type);
	});

	//Clear active filter
	if($('.filter[data-type="'+type+'"].active').length == 0){
		$('.product').removeClass('active-'+type);
	}

	//Clear trigger
	if($('.filter.active').length == 0){
		fTrigger.removeClass('clear')
	}else{
		fTrigger.addClass('clear')
	}

	//Total count
	if($('.module-collection').length){
		$('.module-collection').each(function(){
			var t = $(this),
				 vendor = t.find('.product.active-vendor:not(.active-category)').length,
				 categories = t.find('.product.active-category:not(.active-vendor)').length,
				 both = t.find('.product.active-vendor.active-category').length,
				 count = vendor + categories + both,
				 total = t.find('.product').length;
			if(count == total){
				t.addClass('empty')
			}else{
				t.removeClass('empty')
			}
		});
	}
	var vendor = $('.product.active-vendor:not(.active-category)').length,
		 categories = $('.product.active-category:not(.active-vendor)').length,
		 both = $('.product.active-vendor.active-category').length,
		 count = vendor + categories + both,
		 total = $('.product').length;
	if(count == total){
		$(window).scrollTop(0);
		$('#filters-trigger, #filters').addClass('empty');
	}else{
		$('#filters-trigger, #filters').removeClass('empty');
	}

});

/* Sort
==================================== */
function sortList(t, k, p, target){
	target.sort(function(a, b){
		if(!t.hasClass('active')){
			return $(b).data(k) > $(a).data(k) ? 1 : -1;
		}else{
			return $(b).data(k) < $(a).data(k) ? 1 : -1;
		}
	}).prependTo(p);
}
  /*$('[data-sort]').click(function(){
		var t = $(this),
			 k = t.data('sort'),
			 p = $('.module-list_content'),
			 target = p.find('.module-list_row-wrapper:not([data-'+k+'="null"])');
		t.toggleClass('active');
		$('[data-sort]').not(t).removeClass('active');
		sortList(t, k, p, target)
		if(b.hasClass('template-blog')){
			p = $('.module-gallery'),
			target = p.find('.module-gallery_block');
			sortList(t, k, p, target)
		}
	});*/

//Sort
$('.sort').click(function(){
	var t = $(this),
		 k = t.data('value');
	t.siblings().removeClass('active');
	if(!t.hasClass('active')){
		t.addClass('active');
		$('.module-carousel, .module-products').each(function(){
			var p = $(this);
			p.find('.product:not([data-'+k+'="null"])').sort(function(a, b){
				if(!t.hasClass('invert')){
					return $(b).data(k) < $(a).data(k) ? 1 : -1;
				}else{
					return $(b).data(k) > $(a).data(k) ? 1 : -1;
				}
			}).prependTo(p);
            if($(this).is('.module-carousel')){
                $(this).scrollLeft(0)
            }
		})
	}
});

/* Forms
================================ */
$('.box-wrapper input').keydown(function(){
	t = $(this);
	t.parent().removeClass('success error').addClass('selected');
}).keyup(function(){
	if(t.val().length == 0){
		t.parent().removeClass('selected');
	}
});
$('.box-wrapper .cross').click(function(){
	$(this).parent().removeClass('success error').find('input').val('').focus();
});

/* Cart
================================ */
$('.row-qty select').change(function(e){
	e.preventDefault();
	var t = $(this),
		 val = t.val();
	if(val == '0'){
		t.parent().addClass('error')
	}else{
		t.parent().addClass('success')
	}
	setTimeout(function(){
		$.ajax({
			url: '/cart/change.js',
			type: "post", 
			dataType: 'json',
			data: { 
				"quantity": val,
				"id": t.attr('id')
			},  
			success: function(){
				location.reload();
			},
			error: function(){
				location.reload();
			}
		});
	}, 10);
});

/* Lazy Loading
================================ */
function lazyLoading(t){
	if(t.tagName == 'IMG'){
		t.src = t.dataset.src;
	}
	if(t.tagName == 'VIDEO'){
		var P = t.play();
		if(P !== undefined){
			P.catch(error => {
				if($(t).hasClass('gif')){
					t.classList.add('no-autoplay');
				}else{
					t.classList.add('controls');
					t.controls = true;
				}
			});
		}
	}
	$(t).removeClass('lazy').addClass('lazyloaded')
}

/* Observer Functions
================================ */
var L = [].slice.call(document.querySelectorAll('.lazy'));
if('IntersectionObserver' in window){
	let l = new IntersectionObserver(function(E){
		E.forEach(function(e){
			if(e.isIntersecting){
				let t = e.target;
				lazyLoading(t)
				l.unobserve(t);
			}
		});
	});
	L.forEach(function(t){
		l.observe(t);
	});
}else{
	L.forEach(function(t){
		lazyLoading(t)
	});
}
